exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".UE0EM{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;-ms-flex:0 0 auto;flex:0 0 auto;height:60px;padding:0 18px 0 30px;color:#f0f3f5;background:#3899ec}._2W6OY{-ms-flex:1 1 auto;flex:1 1 auto;margin:0;font-family:HelveticaNeueW01-45Ligh,HelveticaNeueW02-45Ligh,HelveticaNeueW10-45Ligh,Helvetica Neue,ruble,Helvetica,Arial,sans-serif;font-size:18px;font-weight:300}.-w1X3{-ms-flex:0 0 auto;flex:0 0 auto;width:25px;height:25px;margin-left:10px;border-radius:50%;color:inherit;font-size:9px;background:rgba(22,45,61,.2)}.-w1X3:hover{color:inherit;background:#0d487f}._3_ozX{display:none}._3-9hB ._3_ozX{display:block;font-family:HelveticaNeueW01-45Ligh,HelveticaNeueW02-45Ligh,HelveticaNeueW10-45Ligh,Helvetica Neue,ruble,Helvetica,Arial,sans-serif;font-size:16px;font-weight:300;text-align:center}._2nJoN{background:#ee5951}._300ai,._2AfGB{position:relative;height:0}._300ai ._2W6OY,._2AfGB ._2W6OY{display:none}._300ai .xGqmB,._2AfGB .xGqmB{position:absolute;top:12px;right:12px;z-index:10}._2AfGB .xGqmB{top:15px;right:15px}._300ai .xGqmB{background:none;font-size:16px;color:#737373}._300ai .xGqmB:hover{background:none}._1KF8w{position:relative;height:0}._1KF8w ._2W6OY{display:none}._1KF8w .xGqmB{position:absolute;top:18px;right:18px;z-index:10;border-radius:50%;background:#d3edff;color:#3899ec;font-size:9px}", ""]);

// exports
exports.locals = {
	"header": "UE0EM",
	"title": "_2W6OY",
	"button": "-w1X3",
	"help-button": "_3_ozX",
	"helpButton": "_3_ozX",
	"help": "_3-9hB",
	"danger": "_2nJoN",
	"empty": "_300ai",
	"iframe": "_2AfGB",
	"close-button": "xGqmB",
	"closeButton": "xGqmB",
	"simple": "_1KF8w"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./node_modules/postcss-loader??ref--2-2!./node_modules/stylus-loader??ref--2-3!./src/shared/components/modal/header/header.styl
// module id = 669
// module chunks = dashboard/dashboard widget/widget mobile/mobile mobile-overlay/mobile-overlay full-screen-modals/full-screen-modals business-manager/video-library-page